module.exports={
  message: {
    hello: '妳好',
    about: '關於',
    welcome: "歡迎"
  }
}


//////////////////
// WEBPACK FOOTER
// ./static/lang/zhcht.js
// module id = LxFi
// module chunks = 1